import { LDateTime } from '@app/components/date/LDateTime';
import { pushTo } from '@app/core/routing';
import { toDateTimeStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { Edit } from '@mui/icons-material';
import { Box, Chip, IconButton, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReportDefinitionEntity } from '../types';

interface Props {
  definitions: ReportDefinitionEntity[];
  reportType: string;
}

export function ReportDefinitionList({ definitions, reportType: _reportType }: Props) {
  const { formatMessage } = useIntl();

  return (
    <MrtTable<ReportDefinitionEntity>
      data={definitions}
      navigateToOnClick={(id) => `/audit/config/report-definitions/by-id/${id}`}
      columns={[
        {
          header: formatMessage({
            id: 'audit.reportDefinitionList.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          Cell: ({ row: { original } }) => (
            <Box display="flex" alignItems="center" gap={2}>
              <span>{original.name}</span>
              {original.isDefault && (
                <Chip
                  label={
                    <FormattedMessage
                      id="audit.reportDefinitionList.defaultTemplate"
                      defaultMessage="Plantilla default"
                    />
                  }
                  color="primary"
                  variant="outlined"
                  size="small"
                />
              )}
            </Box>
          ),
          size: 200,
          enableGlobalFilter: true,
        },
        // {
        //   header: formatMessage({
        //     id: 'audit.reportDefinitionList.blueprintVersion',
        //     defaultMessage: 'Versión de Blueprint',
        //   }),
        //   accessorKey: 'blueprintVersion',
        //   size: 100,
        //   enableColumnFilter: false,
        //   enableGlobalFilter: false,
        // },
        {
          header: formatMessage({
            id: 'audit.reportDefinitionList.createdAt',
            defaultMessage: 'Creado',
          }),
          accessorKey: 'createdAt',
          Cell: ({ row: { original } }) => <LDateTime value={toDateTimeStr(original.createdAt)} />,
          size: 120,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
          header: formatMessage({
            id: 'audit.reportDefinitionList.actions',
            defaultMessage: 'Acciones',
          }),
          Cell: ({ row: { original } }) => (
            <Tooltip
              title={
                <FormattedMessage
                  id="audit.reportDefinitionList.editTooltip"
                  defaultMessage="Editar"
                />
              }
            >
              <IconButton
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  pushTo(`/audit/config/report-definitions/by-id/${original.id}`);
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          ),
          size: 80,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
      ]}
      enableGlobalFilter
      enableFilters={false}
      memoizeColumns={false}
      enableHiding={false}
      enableColumnActions={false}
    />
  );
}
